exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#radio-has-header {\n  padding-left: 20px;\n}\n#radio-has-header label {\n  padding-right: 10px;\n}\n#radio-pending-inactivate {\n  padding-left: 20px;\n}\n#radio-pending-inactivate label {\n  padding-right: 10px;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/VCopayEPAPharmacyItem.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB","file":"VCopayEPAPharmacyItem.vue","sourcesContent":["\n#radio-has-header {\n  padding-left: 20px;\n}\n#radio-has-header label {\n  padding-right: 10px;\n}\n#radio-pending-inactivate {\n  padding-left: 20px;\n}\n#radio-pending-inactivate label {\n  padding-right: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f978f2a4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VCopayEPAPharmacyItem.vue
// module id = yeRu
// module chunks = 1